export default __webpack_public_path__ + "assets/images/24816f224e18c995455880df29dbd988.gif";